<template>
  <el-table
    class="table"
    :class="[{ 'row-pointer': rowPointer }]"
    ref="common-table"
    :data="data"
    style="width: 100%;"
    :highlight-current-row="tableProps['highlight-current-row']"
    height="100%"
    :stripe="true"
    v-on="$listeners"
    @current-change="onCurrentChange"
  >
    <el-table-column
      style="font-size: 14px"
      v-if="rank"
      label="排名"
      class-name="table-center"
    >
      <template slot-scope="scope">
        <img
          class="rank-img"
          v-if="scope.$index <= 2"
          :src="require(`@/assets/images/rank-${scope.$index + 1}.png`)"
        />
        <span v-else style="height: 23px" class="rank-img">
          {{ scope.$index + 1 }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      v-for="(item, index) in columns"
      :key="index"
      :label="item.label"
      :width="item.width"
      :prop="item.prop"
      :min-width="item.minWidth"
      :class-name="item.center ? 'table-center' : ''"
    >
      <template v-slot:header>
        <div class="header-content">
          <span>{{ item.label }}</span>
          <el-popover
            v-if="item.helpText"
            placement="right"
            trigger="hover"
            popper-class="pop-content"
            :visible-arrow="false"
            :content="item.helpText"
          >
            <i slot="reference" class="icon_xh iconicon_ans"></i>
          </el-popover>
          <div v-if="item.order" class="header-order">
            <i
              class="el-icon-caret-top"
              :class="{ active: item['order'].asc === orderSelect }"
              @click="onOrderAsc(item)"
            />
            <i
              class="el-icon-caret-bottom"
              :class="{ active: item['order'].desc === orderSelect }"
              @click="onOrderDesc(item)"
            />
          </div>
        </div>
      </template>
      <template slot-scope="scope">
        <div :class="[item.tag]" style="width: 100%">
          <template v-if="item.customRender">
            <sj-renderer
              :props="{
                row: scope.row,
                column: {
                  prop: item.prop
                },
                rowIndex: scope.$index
              }"
              :render="item.customRender"
            ></sj-renderer>
          </template>
          <template v-else>
            <CustomElTooltip  v-if="item.formatter" :content="item.formatter(scope.row[item.prop])+''" placement="top" effect="light" closeAutoShow>
              <span>{{ item.formatter(scope.row[item.prop]) }}</span>
            </CustomElTooltip>
            <CustomElTooltip  class="text-ellipsis-2" v-else :content="getTitle(item.type, scope.row[item.prop])+''" placement="top" effect="light" closeAutoShow>
              <span>{{ scope.row[item.prop] }}
                <span v-if="item.type === 'rate'">%</span>
              </span>
            </CustomElTooltip>

            <!-- <span
              v-if="item.formatter"
              :title="item.formatter(scope.row[item.prop])"
            >
              {{ item.formatter(scope.row[item.prop]) }}
            </span> 
            <span
              v-else
              :title="getTitle(item.type, scope.row[item.prop])"
              class="text-ellipsis-2"
            >
              {{ scope.row[item.prop] }}
              <span v-if="item.type === 'rate'">%</span>
            </span>-->
          </template>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import SjRenderer from "@/components/CommonTable/SjRenderer";
import CustomElTooltip from "@/components/CustomElTooltip";

export default {
  name: "CommonTable",
  components: { SjRenderer, CustomElTooltip },
  props: {
    scrollDisabled: {},
    rowPointer: {
      type: Boolean,
      default: true
    },
    tableProps: {},
    data: {},
    center: {
      type: Boolean,
      default: false
    },
    columns: {},
    rank: {
      type: Boolean,
      default: false
    },
    defaultSelected: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selected: null,
      timer: null,
      orderSelect: null
    };
  },
  created() {
    this.orderSelect = this.defaultSelected;
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(list) {
        if (!Array.isArray(list) || !list.length) {
          return;
        }

        if (!~list.findIndex(item => item === this.selected)) {
          this.selectFirst();
        }
      }
    }
  },
  mounted() {
    const dom = this.$refs["common-table"].bodyWrapper;
    const scrollEvent = () => {
      if (this.scrollDisabled) {
        return;
      }
      const scrollTop = dom.scrollTop;
      const clientHeight = dom.getBoundingClientRect().height;
      const scrollHeight = dom.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        if (this.timer !== null) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => this.$emit("infiniteScroll"), 500);
      }
    };
    dom.addEventListener("scroll", scrollEvent);
    this.$once("hook:beforeDestroy", () => {
      dom.removeEventListener("scroll", scrollEvent);
    });
  },
  methods: {
    onOrderAsc(data) {
      if (this.orderSelect === data["order"]["asc"]) {
        return;
      }
      this.orderSelect = data["order"]["asc"];
      this.$emit("order", data["order"]["asc"]);
    },
    onOrderDesc(data) {
      if (this.orderSelect === data["order"]["desc"]) {
        return;
      }
      this.orderSelect = data["order"]["desc"];
      this.$emit("order", data["order"]["desc"]);
    },
    getTitle(type, data) {
      if (type === "rate") {
        return data + "%";
      }
      return data;
    },
    onCurrentChange(data) {
      this.selected = data;
    },
    async selectFirst() {
      await this.$nextTick();
      this.$refs["common-table"].setCurrentRow(this.data[0]);
    }
  }
};
</script>

<style lang="less" scoped>
.rank-img {
  display: block;
  width: 23px;
  text-align: center;
}

.text-ellipsis-2 {
  .text-ellipsis("caption", 2);
}
</style>
<style lang="less">
.pop-content {
  padding: 5px 8px;
  display: flex;
  align-items: center;
}
.table-center {
  .cell {
    text-align: center !important;
    display: flex !important;
    -webkit-box-align: center !important;
    justify-content: center !important;
    align-items: center !important;
    font-weight: normal;
    line-height: normal;
  }
}
/* .row-pointer {
  /deep/.el-table__row {
    cursor: pointer;
  }
} */
.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  .iconicon_ans {
    cursor: pointer;
    margin-left: 3px;
  }
}
.el-table__body tr:hover > td {
  background-color: #e5efff !important;
}
.el-table__body tr.current-row > td {
  background-color: #abd5ff !important;
}
.row-light {
  background-color: #f7f8f9 !important;
}
.el-table__body .cell {
  font-weight: normal !important;
  padding: 0 !important;
  color: #222222;
  * {
    font-size: @xh-font-size !important;
  }
  .iconicon_ans {
    font-size: 20px !important;
    color: #97a3b4;
  }
}
.el-table .has-gutter {
  .cell {
    color: #399bff;
    padding: 0;
    text-align: center !important;
    font-size: 14px;
    .header-order {
      display: flex;
      flex-direction: column;
      color: gray;
      * {
        cursor: pointer;
      }
      .active {
        color: #222222 !important;
      }
    }
    * {
      font-size: 14px;
    }
  }
}
.el-table::before {
  display: none;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: none;
}
.el-table .cell {
  text-align: start;
  display: flex;
  justify-content: flex-start;
  -webkit-box-align: start;
  align-items: center;
  font-weight: normal;
  line-height: normal;
  .text-ellipsis("caption", 2);
}
.el-table td,
th {
  padding: 7.5px 5px !important;
}
.el-table__row td {
  line-height: 18px;
}
</style>
